// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gah8PT {
  display: flex;
  flex-direction: row;
  width: 100%; /* Ocupa todo o espaço disponível */
  height: 908px; /* Altura exata do Figma */
  max-height: 100vh; /* Fallback para telas menores */
  overflow: hidden;
  background: #f9fafc;
}

.MOys6P {
  position: relative;
  flex: 1; /* Ocupa 50% do espaço disponível */
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.SvnmpL {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.i6kKjI {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 10, 10, 1) 0%, rgba(217, 217, 217, 0) 100%);
  z-index: 1;
}

.Q2f_Pt {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 120px 20px 20px 20px;
  color: white;
}

.Gk4ocY {
  font-family: 'Clario', sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 1em;
  margin: 0 0 12px 0;
  color: #ffffff;
}

.FqeIyL {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6em;
  margin: 0 auto;
  color: #ffffff;
  max-width: 255px;
}

.MZbPNC {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1; /* Ocupa 50% do espaço disponível - mesma proporção da esquerda */
  padding: 32px;
  background: #f9fafc;
  min-height: 0; /* Permite flex shrink */
}

.WwgjU6 {
  background: #ffffff;
  border-radius: 4px;
  padding: 24px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Variante usada em telas sem lista de benefícios, onde o texto dos passos é
   mais extenso e precisa de mais largura para não quebrar demais. */
.u3Aj0a {
  max-width: 520px;
}

.O_5Cic {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.424em;
  margin: 0;
  color: #1f1f1f;
  text-align: left;
}

.B_BuUs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.zzg98B {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.NZUIQv {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #f2f2f2;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.KDHiWK {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.421em;
  margin: 0;
  color: #1f1f1f;
  flex: 1;
  white-space: pre-line;
}

.s0Efn8 {
  background: #d64000;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 12px 16px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.424em;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
}

.s0Efn8:hover {
  background: #b23a00;
}

.s0Efn8:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

/* Modal Styles */
.Md_9X0 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.q8q0ef {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
}

.DhlC2h {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  border-bottom: none;
}

.A3_RrW {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4em;
  margin: 0;
  color: #1f1f1f;
}

.XmGUUQ {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 24px;
  width: 32px;
  height: 32px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease;
}

.XmGUUQ:hover {
  color: #1f1f1f;
  background: #f2f2f2;
}

.XmGUUQ:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

.FfZNAj {
  padding: 24px;
}

.Y1hJZY {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

.EnbqWN {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
}

.EnbqWN:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 14px; /* Centraliza abaixo do número (32px/2 - 2px) */
  top: 40px; /* Margem de 8px abaixo do número (32px + 8px) */
  /* Conecta dinamicamente ao próximo número: estende-se pela altura real
     do conteúdo do passo, deixando 8px de margem antes do próximo número
     (gap de 32px entre passos - 8px). */
  bottom: -24px;
  width: 4px;
  border-radius: 4px;
  background-color: #ffba99;
}

.rspPue {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #d64000;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1em;
}

.YL9kZq {
  background: #1a8c3c;
  color: #ffffff;
}

.iZCpft {
  background: #d64000;
  color: #ffffff;
}

.JOcT_6 {
  background: transparent;
  color: #666666;
  border: 2px solid #e0e0e0;
  box-sizing: border-box;
}

/* Connector line color per state */
.o8a65I:not(:last-child)::after {
  background-color: #1a8c3c;
}

.LiLDVO:not(:last-child)::after {
  background-color: #e0e0e0;
}

.eN0dch {
  flex: 1;
}

.cPt6tr {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4em;
  margin: 0 0 8px 0;
  color: #d64000;
}

.dLyGui {
  color: #1a8c3c;
}

.kFFGH3 {
  color: #d64000;
}

.PGqAr_ {
  color: #1f1f1f;
}

.aocK0g {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
  margin: 0;
  color: #666666;
}

.aocK0g strong {
  font-weight: 600;
  color: #1f1f1f;
}

.OoWW6q {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
}

.iTb1AJ {
  background: transparent;
  color: #d64000;
  border: 2px solid #d64000;
  border-radius: 4px;
  padding: 12px 24px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4em;
  cursor: pointer;
  transition: all 0.2s ease;
}

.iTb1AJ:hover {
  background: #d64000;
  color: #ffffff;
}

.iTb1AJ:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

.YvkgZH {
  background: #d64000;
  color: #ffffff;
  border: 2px solid #d64000;
  border-radius: 4px;
  padding: 12px 24px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.YvkgZH:hover {
  background: #b23a00;
  border-color: #b23a00;
}

.YvkgZH:focus {
  outline: 2px solid #d64000;
  outline-offset: 2px;
}

/* Responsividade */
@media (max-width: 768px) {
  .gah8PT {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  .MOys6P {
    flex: none;
    height: 300px;
  }

  .MZbPNC {
    flex: none;
    padding: 20px;
  }

  .WwgjU6 {
    max-width: none;
  }

  .q8q0ef {
    margin: 20px;
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/conta-pj/src/components/ContaPJPromo/ContaPJPromo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW,EAAE,mCAAmC;EAChD,aAAa,EAAE,0BAA0B;EACzC,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO,EAAE,mCAAmC;EAC5C,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wFAAwF;EACxF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO,EAAE,iEAAiE;EAC1E,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAE,wBAAwB;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;oEACoE;AACpE;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ;;8BAE4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,+CAA+C;EAC3D,SAAS,EAAE,gDAAgD;EAC3D;;wCAEsC;EACtC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".promoContainer {\n  display: flex;\n  flex-direction: row;\n  width: 100%; /* Ocupa todo o espaço disponível */\n  height: 908px; /* Altura exata do Figma */\n  max-height: 100vh; /* Fallback para telas menores */\n  overflow: hidden;\n  background: #f9fafc;\n}\n\n.backgroundSection {\n  position: relative;\n  flex: 1; /* Ocupa 50% do espaço disponível */\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.bannerImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  z-index: 0;\n}\n\n.backgroundOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(180deg, rgba(10, 10, 10, 1) 0%, rgba(217, 217, 217, 0) 100%);\n  z-index: 1;\n}\n\n.heroContent {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  padding: 120px 20px 20px 20px;\n  color: white;\n}\n\n.title {\n  font-family: 'Clario', sans-serif;\n  font-size: 32px;\n  font-weight: 400;\n  line-height: 1em;\n  margin: 0 0 12px 0;\n  color: #ffffff;\n}\n\n.subtitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6em;\n  margin: 0 auto;\n  color: #ffffff;\n  max-width: 255px;\n}\n\n.contentSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 1; /* Ocupa 50% do espaço disponível - mesma proporção da esquerda */\n  padding: 32px;\n  background: #f9fafc;\n  min-height: 0; /* Permite flex shrink */\n}\n\n.card {\n  background: #ffffff;\n  border-radius: 4px;\n  padding: 24px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  width: 100%;\n  max-width: 350px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Variante usada em telas sem lista de benefícios, onde o texto dos passos é\n   mais extenso e precisa de mais largura para não quebrar demais. */\n.cardWide {\n  max-width: 520px;\n}\n\n.cardTitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.424em;\n  margin: 0;\n  color: #1f1f1f;\n  text-align: left;\n}\n\n.benefitsList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.benefit {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.benefitIcon {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  background: #f2f2f2;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.benefitText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.421em;\n  margin: 0;\n  color: #1f1f1f;\n  flex: 1;\n  white-space: pre-line;\n}\n\n.ctaButton {\n  background: #d64000;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 16px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.424em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  width: 100%;\n}\n\n.ctaButton:hover {\n  background: #b23a00;\n}\n\n.ctaButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 24px 0 24px;\n  border-bottom: none;\n}\n\n.modalTitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.4em;\n  margin: 0;\n  color: #1f1f1f;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  color: #666666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 24px;\n  width: 32px;\n  height: 32px;\n  transition:\n    color 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.closeButton:hover {\n  color: #1f1f1f;\n  background: #f2f2f2;\n}\n\n.closeButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n.modalContent {\n  padding: 24px;\n}\n\n.steps {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  margin-bottom: 32px;\n}\n\n.step {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  position: relative;\n}\n\n.step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  left: 14px; /* Centraliza abaixo do número (32px/2 - 2px) */\n  top: 40px; /* Margem de 8px abaixo do número (32px + 8px) */\n  /* Conecta dinamicamente ao próximo número: estende-se pela altura real\n     do conteúdo do passo, deixando 8px de margem antes do próximo número\n     (gap de 32px entre passos - 8px). */\n  bottom: -24px;\n  width: 4px;\n  border-radius: 4px;\n  background-color: #ffba99;\n}\n\n.stepNumber {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  background: #d64000;\n  color: #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1em;\n}\n\n.stepNumberDone {\n  background: #1a8c3c;\n  color: #ffffff;\n}\n\n.stepNumberCurrent {\n  background: #d64000;\n  color: #ffffff;\n}\n\n.stepNumberPending {\n  background: transparent;\n  color: #666666;\n  border: 2px solid #e0e0e0;\n  box-sizing: border-box;\n}\n\n/* Connector line color per state */\n.stepDone:not(:last-child)::after {\n  background-color: #1a8c3c;\n}\n\n.stepPending:not(:last-child)::after {\n  background-color: #e0e0e0;\n}\n\n.stepContent {\n  flex: 1;\n}\n\n.stepTitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4em;\n  margin: 0 0 8px 0;\n  color: #d64000;\n}\n\n.stepTitleDone {\n  color: #1a8c3c;\n}\n\n.stepTitleCurrent {\n  color: #d64000;\n}\n\n.stepTitlePending {\n  color: #1f1f1f;\n}\n\n.stepDescription {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5em;\n  margin: 0;\n  color: #666666;\n}\n\n.stepDescription strong {\n  font-weight: 600;\n  color: #1f1f1f;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 32px;\n}\n\n.cancelButton {\n  background: transparent;\n  color: #d64000;\n  border: 2px solid #d64000;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4em;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background: #d64000;\n  color: #ffffff;\n}\n\n.cancelButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n.portalButton {\n  background: #d64000;\n  color: #ffffff;\n  border: 2px solid #d64000;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.portalButton:hover {\n  background: #b23a00;\n  border-color: #b23a00;\n}\n\n.portalButton:focus {\n  outline: 2px solid #d64000;\n  outline-offset: 2px;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .promoContainer {\n    flex-direction: column;\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .backgroundSection {\n    flex: none;\n    height: 300px;\n  }\n\n  .contentSection {\n    flex: none;\n    padding: 20px;\n  }\n\n  .card {\n    max-width: none;\n  }\n\n  .modal {\n    margin: 20px;\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promoContainer": `gah8PT`,
	"backgroundSection": `MOys6P`,
	"bannerImage": `SvnmpL`,
	"backgroundOverlay": `i6kKjI`,
	"heroContent": `Q2f_Pt`,
	"title": `Gk4ocY`,
	"subtitle": `FqeIyL`,
	"contentSection": `MZbPNC`,
	"card": `WwgjU6`,
	"cardWide": `u3Aj0a`,
	"cardTitle": `O_5Cic`,
	"benefitsList": `B_BuUs`,
	"benefit": `zzg98B`,
	"benefitIcon": `NZUIQv`,
	"benefitText": `KDHiWK`,
	"ctaButton": `s0Efn8`,
	"modalOverlay": `Md_9X0`,
	"modal": `q8q0ef`,
	"modalHeader": `DhlC2h`,
	"modalTitle": `A3_RrW`,
	"closeButton": `XmGUUQ`,
	"modalContent": `FfZNAj`,
	"steps": `Y1hJZY`,
	"step": `EnbqWN`,
	"stepNumber": `rspPue`,
	"stepNumberDone": `YL9kZq`,
	"stepNumberCurrent": `iZCpft`,
	"stepNumberPending": `JOcT_6`,
	"stepDone": `o8a65I`,
	"stepPending": `LiLDVO`,
	"stepContent": `eN0dch`,
	"stepTitle": `cPt6tr`,
	"stepTitleDone": `dLyGui`,
	"stepTitleCurrent": `kFFGH3`,
	"stepTitlePending": `PGqAr_`,
	"stepDescription": `aocK0g`,
	"modalActions": `OoWW6q`,
	"cancelButton": `iTb1AJ`,
	"portalButton": `YvkgZH`
};
module.exports = ___CSS_LOADER_EXPORT___;
